import Checkbox from "@mui/material/Checkbox";
import { useEffect, useState } from "react";

const CheckboxRenderer = ({ checked, onChange, id }) => {
  const [isChecked, setIsChecked] = useState(checked);

  const [isIndeterminate, setIsIndeterminate] = useState(false);

  useEffect(() => {
    setIsChecked(checked);
    if (checked === null) {
      setIsIndeterminate(true);
    } else {
      setIsIndeterminate(false);
    }
  }, [checked]);

  console.log(isChecked, checked);

  return (
    <Checkbox
      key={id}
      indeterminate={isIndeterminate}
      checked={isChecked}
      onChange={() => {
        onChange();
      }}
    />
  );
};

export default CheckboxRenderer;
